import React from 'react';
import { useTranslation } from 'react-i18next';
import { buildHistoryParcelHref, HistoryLinkSource, HistoryParcelSystem } from './historyLink';
import './parcelQueryRange.css';

interface HistoryParcelLinkProps {
    system: HistoryParcelSystem;
    /** 当前已填写的筛选条件（按白名单带入，见 buildHistoryParcelHash） */
    filters: Record<string, any> | null | undefined;
    /** 覆盖带入的字段，如 R7 只带入未查到的运单号 */
    override?: Record<string, any>;
    source: HistoryLinkSource;
}

/** 「历史包裹查询」链接：新标签页打开并回填筛选条件 */
const HistoryParcelLink: React.FC<HistoryParcelLinkProps> = ({ system, filters, override, source }) => {
    const { t } = useTranslation();
    return (
        <a
            className="pqr-link"
            href={buildHistoryParcelHref(system, filters, override)}
            target="_blank"
            rel="noopener noreferrer"
            data-source={source}
        >
            {t('parcelQueryRange.historyLink')}
        </a>
    );
};

export default HistoryParcelLink;
